import { render, staticRenderFns } from "./SfArrow.vue?vue&type=template&id=a40e51b4&functional=true"
import script from "./SfArrow.vue?vue&type=script&lang=js"
export * from "./SfArrow.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfArrow.vue?vue&type=style&index=0&id=a40e51b4&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "4395ad35"
  
)

export default component.exports